export * from './IconWideScreenStroked';
